export const constants = {
  soloChallengeReview: "soloChallengeReview",
  gDrivePrefix: "drive",
};
